import React, { useState, useEffect } from 'react';
import { Tab, Nav, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ReactStars from 'react-stars';
import AddVendorModal from './Modal/AddVendorModal';
import ConfirmationModal from './Modal/ConfirmationModal';
import { getAllVendors } from '../../services/vendorServices';
import { Form } from 'react-bootstrap';

const Vendors = () => {
  const [vendors, setVendors] = useState([]);
  const [sortOption, setSortOption] = useState('newest');
  const [searchQuery, setSearchQuery] = useState(''); // Holds search input

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total pages from API
  const itemsPerPage = 5; // Items per page
  const [totalEntries, setTotalEntries] = useState(0);
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => {
    const fetchVendors = async () => {
      const data = await getAllVendors({
        page: currentPage,
        limit: itemsPerPage,
        sortOption,
      }); // Fetch page 1 with 10 vendors
      if (data.success) {
        setVendors(Array.isArray(data.vendors) ? data.vendors : []);
        setTotalPages(data?.totalPages); // ✅ Update total pages
        setTotalEntries(data.totalRecords); // ✅ Ensure this is updated
      } else {
        setError(data.error);
      }
      setLoading(false);
    };

    fetchVendors();
  }, [sortOption, currentPage]);

  useEffect(() => {
    let tempData = [...vendors];

    // 🔍 **Search Filter**
    if (searchQuery.trim()) {
      tempData = tempData.filter(
        (row) =>
          row?.name.toLowerCase().includes(searchQuery.toLowerCase().trim()) ||
          row?.email.toLowerCase().includes(searchQuery.toLowerCase().trim())
      );
    }
    const filteredQueries = tableData.filter((query) => {
      const matchesStatus = !statusFilter || query.status.toLowerCase() === statusFilter.toLowerCase();
      return matchesStatus;
    });
    setTableData(tempData);
  }, [searchQuery, vendors]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="">
      <Tab.Container defaultActiveKey="All">
        <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
          <div className="card-action vendor-tabs mb-2">
            <Nav as="ul" className="nav nav-tabs" role="tablist">
              <Nav.Item as="li" className="nav-item">
                <Nav.Link className="nav-link" eventKey="All">
                  Vendors
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <div className="d-flex align-items-center mb-2">
            <div className="card-action coin-tabs mb-1 d-flex align-items-center">
              <style>
                {`
              .custom-placeholder::placeholder {
                color: rgba(255, 99, 132);
                opacity: 1;
                
              }
            `}
              </style>
              <Form.Control
                type="text"
                placeholder="Search by vendors name..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="custom-placeholder shadow-md"
                style={{
                  border: '1px solid rgba(255, 99, 132)',
                  height: '50px',
                  width: '250px',
                  fontWeight: '400',
                  fontSize: '14px',
                  // marginRight: "10px",
                  backgroundColor: 'transparent',
                }}
              />
            </div>
            <div className="sort-options ms-3">
              <Dropdown>
                <Dropdown.Toggle as="div" className="btn-select-drop default-select btn i-false">
                  {sortOption} <i className="fas fa-angle-down ms-2"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setSortOption('newest')} eventKey="Newest">
                    Newest
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setSortOption('oldest')} eventKey="Oldest">
                    Oldest
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All" active show>
                    <div className="table-responsive">
                      <table className="table card-table display mb-4 vendor-table">
                        <thead className="w-full">
                          <tr className="w-full">
                            <th className="w-[20%]">Vendor Name</th>
                            <th>Category</th>
                            <th>Location</th>
                            <th>Contact</th>
                            <th>Contracts</th>
                            <th>Performance</th>
                            <th className="w-[20%]">Feedback</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.map((vendor) => (
                            <tr key={vendor.id} className="text-base w-full">
                              <td className="w-[20%]">
                                <span className="text-lg text-secondary">{vendor.name}</span>
                              </td>
                              <td>{vendor.category}</td>
                              <td>{vendor.location}</td>
                              <td>{vendor.contact}</td>
                              <td>{vendor.email}</td>
                              <td>{vendor.performance}</td>
                              <td className="w-[10%]">
                                <ReactStars count={5} value={vendor.averageRating} size={24} color2={'#ffd700'} />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {vendors.length > 0 && (
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-3">
                          <div className="dataTables_info">
                            Showing {(currentPage - 1) * itemsPerPage + 1} to{' '}
                            {Math.min(currentPage * itemsPerPage, totalEntries)} of {totalEntries} entries
                          </div>
                          <div className="dataTables_paginate paging_simple_numbers mb-0">
                            <Link
                              className={`paginate_button previous ${currentPage === 1 ? 'disabled' : ''}`}
                              onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                            >
                              <i className="fa fa-angle-double-left"></i> Previous
                            </Link>
                            <span>
                              {[...Array(totalPages)].map((_, i) => (
                                <Link
                                  key={i}
                                  className={`paginate_button ${currentPage === i + 1 ? 'current' : ''}`}
                                  onClick={() => setCurrentPage(i + 1)}
                                >
                                  {i + 1}
                                </Link>
                              ))}
                            </span>
                            <Link
                              className={`paginate_button next ${currentPage === totalPages ? 'disabled' : ''}`}
                              onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                            >
                              Next <i className="fa fa-angle-double-right"></i>
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </div>
  );
};

export default Vendors;
